import CommonButtonReload from "@/components/common/button-reload"

export default function ErrorMessage({ message }: { message: string }) {
  return (
    <div
      className={`
        flex flex-col items-center text-center
        gap-7
        pt-16
      `}
    >
      <h2 className="text-[18px] md:text-[32px]">アクセスエラー</h2>
      <p className="text-[14px] md:text-[18px] leading-[1.6em]">
        {message}の読み込みに失敗しました。
        <br />
        しばらく経ってからお試しください。
      </p>
      <CommonButtonReload />
    </div>
  )
}
